<template>
  <v-layout class="cabinet back">
    <v-layout v-if="data.template" column ref="cabinetWrapper" class="wrapper" ma-0 pa-0>
      <div :style="`width: ${cabinet.width}px; height: ${cabinet.height_top}px; backgroundImage: url('${getBackground(this.data.template, 'top')}'); backgroundSize: contain;`"></div>
      <v-layout v-if="cabinet.unit" v-for="(position, index) in getUnitPosition" :key="index" ma-0 pa-0>
        <div
          v-if="cabinet.unit[position].open"
          :id="position"
          class="unit text-xs-center display-1"
          :style="`width: ${cabinet.width}px; backgroundImage: url('${getBackground(data.template, 'unit')}')`"
        >
          <v-layout fill-height justify-center>
            <div class="open" v-if="$store.state.auth.user.level <= 1" @click.stop="() => onSelect(position)">
              <v-icon 
                large
                :color="'white'" 
                style="margin-left: 0px; margin-top: 2px">
                  add_circle
              </v-icon>
            </div>
            <div class="open" v-else>
              <v-icon 
                large
                :color="'white'" 
                style="margin-left: 0px; margin-top: 2px">
                  add_circle
              </v-icon>
            </div>
          </v-layout>
        </div>

        <div
          v-if="!cabinet.unit[position].open"
          :id="position"
          class="unit text-xs-center display-1"
          :style="`width: ${cabinet.width}px; backgroundImage: url('${getBackground(data.template, 'unit')}'); position: relative`"

        >
          <v-flex class="open-inverse" :id="position + '_'" style="margin-left: 74px; position: absolute;" @click="() => onSelect(position)">
              <v-icon 
                large
                :color="'white'" 
                >
                  add_circle
              </v-icon>
          </v-flex>
                
          <v-layout fill-height ma-0
            v-for="device in checkPosition(position)"
            :key="device.$id"
            justify-space-between
            style="position: absolute"
          >
            <v-flex  v-if="device" :style="`padding-left: 6px; width: 40px; background-color: transparent`">
            </v-flex>

            <v-flex shrink class="closed" :style="`padding-left: ${4 + (cabinet.width - 580)/2}px;`">
              <device
                :data="device"
                :cabinet="cabinet"
                :side="cabinet.side"
                :position="position"
                @select="(payload) => onSelect(payload)"
                @delete="(payload) => onDelete(payload, index)"
              />
            </v-flex>

            <v-flex :style="`padding-left: ${88 + (cabinet.width - 580)/2}px;`">
              <v-icon large v-if="device.mount == mount" :color="$getColor($store.getters.getStatus[device.$id])">brightness_1_outline</v-icon>
            </v-flex>
          </v-layout>
        </div>

        <div class="headline test-xs-center unit-positions">
          {{position}}
        </div>
      </v-layout>
      <div :style="`width: ${cabinet.width}px; height: ${cabinet.height_bottom}px; backgroundImage: url('${getBackground(data.template, 'bottom')}'); backgroundSize: contain;`"></div>
    </v-layout>
  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
import Device from '@/nms/components/device/device.vue'

// Типы
interface DeviceItem {
  $id?: string
  id?: string
  cls?: string
  name?: string
  template?: string
  height?: number
  position?: number
  width?: number
  [key: string]: any
}

interface CabinetTemplate {
  top: string | null
  bottom: string | null
  main: string | null
}

interface UnitDevice {
  $id?: string
  [key: string]: any
}

interface UnitItem {
  id: number
  open: boolean
  unit: any | null
  device?: UnitDevice[]
}

interface CabinetUnit {
  [key: number]: UnitItem
}

interface CabinetData {
  $id?: string
  id?: string
  cls?: string
  name?: string
  template?: string
  usize?: number
  width?: number
  height_top?: number
  height_bottom?: number
  children?: DeviceItem[]
  [key: string]: any
}

interface ClosedUnit {
  position: number
  device: DeviceItem[]
}

interface CabinetState {
  template: CabinetTemplate
  devices: DeviceItem[]
  closed: ClosedUnit[]
  size: number | null
  side: string
  width: number
  height_top: number
  height_bottom: number
  unit: CabinetUnit
}

interface StatusesMap {
  [key: string]: string
}

export default Vue.extend({
  name: 'CABINET_COMPONENT',

  components: {
    Device,
  },

  props: {
    data: {
      type: Object as () => CabinetData,
      default: () => ({})
    },
    mount: {
      type: String,
      default: () => 'front'
    },
  },

  data(): {
    cabinet: CabinetState
    statuses: StatusesMap
  } {
    return {
      cabinet: {
        template: {
          top: null,
          bottom: null,
          main: null
        },
        devices: [],
        closed: [],
        size: null,
        side: '',
        width: 1000,
        height_top: 60,
        height_bottom: 68,
        unit: {},
      },
      statuses: {},
    }
  },

  computed: {
    getDevices(): DeviceItem[] | undefined {
      if (!this.data) return undefined
      return this.cabinet.devices
    },

    getUnitPosition(): number[] {
      return Object.keys(this.cabinet.unit).map(Number).slice().reverse()
    },

    getData(): CabinetData {
      return this.data
    },

    getStatuses(): StatusesMap {
      return this.statuses
    },
  },

  watch: {
    data: {
      handler(newVal: CabinetData): void {
        if (!newVal) return
        this.setup()
      },
      deep: true
    },
    mount: {
      handler(newVal: string): void {
        console.log('WATCH', this.$options.name, 'mount', newVal)
        if (!newVal) return
        this.setup()
      },
      deep: true
    },
  },

  created(): void {
    this.$set(this.cabinet.template, 'top', this.getBackground(this.data.template, 'top'))
    this.$set(this.cabinet.template, 'bottom', this.getBackground(this.data.template, 'bottom'))
    this.$set(this.cabinet.template, 'unit', this.getBackground(this.data.template, 'unit'))
    this.setup()
  },

  beforeDestroy(): void {
    this.statusUnsubscribe()
  },

  methods: {
    async setup(): Promise<void> {
      this.reset()
      try {
        this.statusUnsubscribe()
        this.$set(this.cabinet, 'size', this.getData.usize || 42)
        this.$set(this.cabinet, 'side', this.mount || 'front')
        this.$set(this.cabinet, 'width', this.getData.width || 1000)
        this.$set(this.cabinet, 'height_top', this.getData.height_top || 60)
        this.$set(this.cabinet, 'height_bottom', this.getData.height_bottom || 68)
        
        if (this.data.children) {
          this.$set(this.cabinet, 'devices', [])
          this.data.children.forEach((device: DeviceItem) => {
            this.cabinet.devices.push(device)
          })
        }
        this.createUnits()
        this.addUnitStatus()
      } catch (err) {
        console.error(this.$options.name, 'setup error', err)
      }
    },

    createUnits(): void {
      this.cabinet.unit = {}
      const size = this.cabinet.size || 0
      for (let i = 0; i < size; i++) {
        this.cabinet.unit[i + 1] = {
          id: i + 1,
          open: true,
          unit: null
        }
      }
    },

    addUnitStatus(): void {
      this.cabinet.closed = []
      this.cabinet.devices.forEach((device: DeviceItem) => {
        const deviceHeight = device.height || 0
        
        if (deviceHeight > 45) {
          const count = Math.ceil(deviceHeight / 45)
          const position = device.position || 0
          
          for (let i = position; i > position - count; i--) {
            if (!this.cabinet.unit[i]) return
            
            this.cabinet.unit[i].open = false
            if (!this.cabinet.unit[i].device) {
              this.cabinet.unit[i].device = []
            }
            this.cabinet.unit[i].device.push(device)
            
            const existingClosed = this.cabinet.closed.find(u => u.position == i)
            if (existingClosed) {
              existingClosed.device.push(device)
            } else {
              this.cabinet.closed.push({
                position: i,
                device: [device]
              })
            }
          }
        } else {
          const position = device.position || 0
          if (!this.cabinet.unit[position]) return
          
          this.cabinet.unit[position].open = false
          if (!this.cabinet.unit[position].device) {
            this.cabinet.unit[position].device = []
          }
          this.cabinet.unit[position].device.push(device)
          
          const existingClosed = this.cabinet.closed.find(u => u.position == position)
          if (existingClosed) {
            existingClosed.device.push(device)
          } else {
            this.cabinet.closed.push({
              position: position,
              device: [device]
            })
          }
        }
      })
      this.$emit('closed', this.cabinet.closed)
      console.log(this.$options.name, 'addUnitStatus', this.cabinet.closed)
      this.statusSubscribe()
    },

    checkPosition(position: number): DeviceItem[] {
      const devices = this.getDevices?.filter(device => {
        return device.position && device.position == position
      }) || []
      return devices
    },

    onSelect(payload: any): void {
      console.log(this.$options.name, 'onSelect', payload)
      
      if (typeof payload === 'object') {
        this.$store.dispatch('activeDevice', payload)
      } else {
        const unit = {
          cls: 'unit',
          position: payload,
          side: this.cabinet.side,
          closed: this.cabinet.closed,
          cabinet: {
            obj: this.getData,
            name: this.getData.name,
            cls: this.getData.cls,
            id: this.getData.id,
            usize: this.getData.usize,
          }
        }
        this.$store.dispatch('activeDevice', unit)
      }
    },

    onDelete(payload: DeviceItem, index: number): void {
      this.cabinet.devices.splice(index, 1)
      this.createUnits()
      this.addUnitStatus()
      this.$emit('deleteDevice', payload)
    },

    getBackground(data: string | undefined, side: string): string | undefined {
      if (!data) return undefined
      const path = this.$bridge.getImageLinkByTemplate('cabinet', data, side)
      if (path) {
        return path.replace(/\s/g, '%20')
      }
      return undefined
    },

    async statusSubscribe(): Promise<void> {
      this.$store.dispatch('measuresSubscribeInit', {
        name: 'addStatus',
        group: 'cabinet',
        listener: 'status'
      })
      
      if (this.cabinet.devices?.length) {
        await this.$bridge.subscribe(this.cabinet.devices.map(device => device.$id))
      }
    },

    subscribeHandler(e: { $id?: string; state?: { infoState?: string }; [key: string]: any }): void {
      if (e.$id) {
        const status = e.state?.infoState || 'unknown'
        this.$set(this.statuses, e.$id, status)
      }
    },

    statusUnsubscribe(): void {
      this.$store.dispatch('measuresSubscribeClose', {
        handler: this.subscribeHandler,
        group: 'cabinet',
        listener: 'status'
      })
    },

    reset(): void {
      this.cabinet = {
        template: {
          top: null,
          bottom: null,
          main: null
        },
        devices: [],
        closed: [],
        size: null,
        side: '',
        width: 1000,
        height_top: 60,
        height_bottom: 68,
        unit: {},
      }
      this.statuses = {}
    },
  },
})
</script>

<style scoped>

.cabinet {
  /* height: 44.5px;
  width: 603px; */
  height: 100%;
  width: 100%;
  /* transform-origin: 0 0; */
  /* transform: scale(.45); */
  /* left: 28px; */
  /* top: 28px; */
  cursor: pointer;
  /* padding: 14px 0px 20px 6px; */
  position: relative;
  /* position: absolute; */
}

.cabinet-head {
  /* height: 60px; */
  /* width: 603px; */
  /* background-image: url(template/up.png); */
  /* position: absolute; */
}

.cabinet-bottom {
  /* height: 68px; */
  /* width: 603px; */
  /* background-image: url(template/down.png); */
  /* position: absolute; */
}

.wrapper {
  left: 15%;
  /* height: 44.5px;
  width: 603px; */
  /* height: 100%;
  width: 100%; */
  transform-origin: 0 0;
  transform: scale(.368);
  /* left: 28px;
  top: 28px; */
  /* cursor: pointer; */
  /* padding: 14px 0px 20px 6px; */
  /* position: relative; */
  position: absolute;
}

.unit {
  height: 45px;
  /* width: 603px; */
  /* background-size: contain; */
  /* height: 44.5px;
  width: 450px; */
  /* background-color: white; */
  /* box-sizing: border-box; */
  /* border: solid 1px grey; */
  cursor: pointer;
  /* background-image: url(template/unit_.png); */
  /* transform-origin: 0 0; */
  /* transform: scale(.45); */
  /* display: none; */
  /* border: solid 1px grey; */
  /* position: relative; */
  /* color: #fff; */
  /* color: transparent; */
  /* padding: 1px 1px 1px 1px; */
}


.unit-positions {
  /* width: 80px; */
  display: flex;
  justify-content: flex-end;
  /* height:900px; */
  padding: 6px 0px 0px 8px;

  /* position: relative; */
  /* background-color: white; */
  /* border: solid 1px grey */
}
/* .unit:hover {
  height: 44.5px;
  width: 450px;
  background-color: #F7941D;
  box-sizing: border-box;
  border: solid 1px grey;
  position: relative;

} */


.open {
  background-color: white;
  height: 45px;
  /* width: 490px; */
  width: 450px;
  box-sizing: border-box;
  border: solid 1px grey;
}

.open:hover {

  background-color: #197C56;
  /* background-color: #F7941D; */

}

.open:hover::after {

  /* content: 'Добавить устройство'; */
  color: #fff;

}

.open-inverse { 
  background-color: transparent;
  height: 45px;
  /* width: 490px; */
  width: 450px;
  box-sizing: border-box;
  /* border: solid 1px grey; */
  z-index: 3;
}

.open-inverse:hover {

  background-color: #197C56;
  z-index: 3;
  /* background-color: #F7941D; */

}

.open-inverse:hover::after {

  /* content: 'Добавить устройство'; */
  color: #fff;

}

.closed {
  background-color: transparent;
  /* height: 45px;
  width: 450px; */
  /* width: 490px; */
  /* width: 450px; */
}

/* .closed-active {
  outline: solid 2px orange;
} */

</style>
